import { createRefetchContainer, graphql } from 'react-relay';
import ContactSearch from './ContactSearch';

export default createRefetchContainer(ContactSearch,
  {
    viewer: graphql`
      fragment ContactSearchContainer_viewer on User
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 3 },
        query: { type: "String!", defaultValue: "" }
      ) {
        user_contact_search(first: 3, query: $query) {
          edges{
            node{
              id
              first_name
              last_name
              user_contact_emails {
                edges {
                  node {
                    address
                  }
                }
              }
              user_contact_phones {
                edges {
                  node {
                    number
                  }
                }
              }
            }
          }
        }
      }`
  },
  graphql`
    query ContactSearchContainerRefetchQuery($query: String!) {
      viewer {
        ...ContactSearchContainer_viewer @arguments(query: $query)
      }
    }
  `
);



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/ContactSearchContainer.js